import { render } from "./DropdownInput.vue?vue&type=template&id=67368911&scoped=true&ts=true"
import script from "./DropdownInput.vue?vue&type=script&lang=ts"
export * from "./DropdownInput.vue?vue&type=script&lang=ts"

import "./dropdown-input.scss?vue&type=style&index=0&id=67368911&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67368911"]])

export default __exports__